import type { DashboardSharingType } from '@risksmart-app/domain/src/types/consts/dashboard-sharing-type';
import type {
  InputMaybe,
  Scalars,
  UpdateDashboardMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  namedOperations,
  UpdateDashboardDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface UpdateDashboardInput {
  Id: string;
  Name: string;
  Description?: InputMaybe<string>;
  Sharing: DashboardSharingType;
  Content?: InputMaybe<Scalars['jsonb']['input']>;
  ContributorUserIds: string[];
  ContributorGroupIds: string[];
}

export const useUpdateDashboard = createMutationHook({
  name: 'updateDashboard',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.dashboard.update.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateDashboardInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.dashboard.dashboards.queryKey(),
    trpc.frontend.dashboard.dashboardById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): UpdateDashboardMutation => ({
    updateChildDashboard: { __typename: 'IdOutput', Id: result.Id },
  }),
  graphqlDocument: UpdateDashboardDocument,
  graphqlVariables: (input: UpdateDashboardInput) => ({
    Id: input.Id,
    Name: input.Name,
    Description: input.Description,
    Sharing: input.Sharing,
    Content: input.Content,
    ContributorUserIds: input.ContributorUserIds,
    ContributorGroupIds: input.ContributorGroupIds,
  }),
  refetchQueries: [
    namedOperations.Query.getDashboards,
    namedOperations.Query.getDashboardById,
  ],
});
